import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';

// Component
import Organisations from "./Organisations";
import DeleteConfirmationModal from "../Users/DeleteConfirmationModal";
import Spinner from "../../Spinner/Spinner";

import { getMessage } from "CONFIG/i18n";
import { CONFIG, modulesAvailableConstant } from "../../../Utils/Constants";
import { displayError } from "UTILS/Utility";
import { validateUserName } from "UTILS/regexValidations";
import {getCurrentDateTimeInLocalTimezone} from "UTILS/DateUtils";

// Images
import ic_audio from "ASSETS/Images/header_center/ic_audio_deactivate.svg";
import ic_canvas from "ASSETS/Images/header_center/ic_canvas_deactivate.svg";
import ic_message from "ASSETS/Images/header_center/ic_message_deactivate.svg";
import ic_video from "ASSETS/Images/header_center/ic_video_deactivate.svg";
import ic_share from "ASSETS/Images/header_center/ic_share_deactivate.svg";
import ic_location from "ASSETS/Images/header_center/ic_location_deactivate.svg";
import ic_camera from "ASSETS/Images/header_center/ic_snapshot_deactivate.svg";
import ic_admin_co_browse from "ASSETS/Images/header_center/ic_co_browse_deactivate.svg";
import ic_QR_code from "ASSETS/Images/ic_QR_code.svg";
import download_img from "ASSETS/Images/ic_download_allow.svg";
import ic_app_emulation from "ASSETS/Images/ic_app_emulation_small.svg";
import ic_pdf from "ASSETS/Images/pdf/ic_pdf.svg";

import { ERROR } from "UTILS/Constants";
import { convertMinutesToDDhhmm } from "UTILS/DateUtils";

//actions
import { organisationAction, userAction } from "CONFIG/ActionFactory";

import { TIMEOUT } from "UTILS/Constants";

const customerObjectInitialState = {
  id: "",
  name: "",
  seats: "",
  modules: [],
  firstName: "",
  lastName: "",
  username: "",
  license_expiry: new Date(),
  license_key: "",
  admin: [],
  logo:"",
  msClusterInfo:[],
  turnClusterInfo:[],
};

class OrganisationsContainer extends Component {
  constructor(props) {
    super(props);
    this.subscribe = null;
    this.addOrgRef = React.createRef();
    this.getStatus = React.createRef();
    this.state = {
      responseObject: { data: [] },
      searchedCustomer: { data: [] },
      showAddOrganizationModal: false,
      showEditOrganizationModal: false,
      editOrganisationData: customerObjectInitialState,
      editOrganisationIndex: -1,
      check: null,
      showConfirmationModalFlag: false,
      deleteCustomerId: null,
      deleteTarget: "",
      errorMessage: "",
      customerId: "",
      isSearchResult: false,
      searchString: "",
      sortByKey:true, // if sortByKey == true desc if false asc
      lastRefreshTime:"",
      lastRefreshTimeTurn:"",
      isKurentoServerOn: false,
      summaryData: {
        totalCustomers:{label:getMessage("NUMBER_OF_CUSTOMER_ACCOUNTS"),value:0},
        usedAndMaxCapacity:{label:`${getMessage("USED_CAPACITY")}/${getMessage("TOTAL_CAPACITY")}`,value:0},
        totalSessions:{label:getMessage("NUMBER_OF_TOTAL_SESSIONS"), value: 0 },
        activeSessions:{label:getMessage("NUMBER_OF_ACTIVE_SESSIONS"), value: 0 },
        totalTimeToDate:{label:getMessage("TOTAL_USAGE_TO_DATE"), value:0}
      }
    };
  }

  componentDidMount() {
    this.showSpinner();
    this.getAllCustomerData();
    this.getServerStatusAndUsersCount();
    if(this.props.usingKmsCluster) {
      this.getClusterInfo();
    } 
    if(this.props.usingTurnCluster) {
      this.getTurnClusterInfo();
    } 

  }
   getClusterInfo =() =>{
     organisationAction.getMSClusterStatistcsAction().then(
       clusterData =>{
         this.setState({
           msClusterInfo: clusterData.data.data,
           lastRefreshTime: getCurrentDateTimeInLocalTimezone(this.props.language)
         })
       } 
     )
   }

    getTurnClusterInfo = () =>{
      organisationAction.getTurnClusterStatisticsAction().then(
        turnClusterData =>{
          this.setState({
            turnClusterInfo: turnClusterData.data.data,
            lastRefreshTimeTurn: getCurrentDateTimeInLocalTimezone(this.props.language)
          })
        } 
      )
    }

   retireInstance = (selectedInstances, callback) =>{
     organisationAction.retireMsClusterInstanceAction(selectedInstances).then(
       retireInstance=> {
         toastr.success(getMessage(retireInstance.data.data));
         if(callback) callback("success")
       },
       error=>{
         if(error.code)
           toastr.error(getMessage(error.code));
         if(callback) callback();
       }
     ).catch (
       error => {
         if(error.code)
           toastr.error(getMessage(error.code));
         if(callback) callback();
       }
     )
   } 

  getAllCustomerData = () => {
    organisationAction.getAllCustomersAction().then(
      response_data => {
        let responseObject = this.sortCustomerList(response_data.data);
        this.hideSpinner()
        this.setState({
          mountOrganisationList: true
        })
        this.setState({ responseObject: responseObject }, () => {
          this.state.isSearchResult ? this.handleSearchString() : null;
        });
      },
      error => {
        this.hideSpinner()
      }
    );
  };

  sortCustomerList = (response_data, changeFlag=false) => {
    let sortBy = 'desc'
    if(changeFlag){
      sortBy = this.state.sortByKey ? 'desc' : 'asc' ;
      this.setState({sortByKey: !this.state.sortByKey});
    } 
    let arrayOfCustomer = _.orderBy(response_data.data, [customer => customer.name.toLowerCase()],[sortBy]);
    response_data.data = arrayOfCustomer;
    return response_data;
  }

  handleAddClick = (customerWithAdminData, callBackForError) => {
    organisationAction.addCustomerWithAdminAction(customerWithAdminData).then(
      response_data => {
        toastr.success(getMessage("ORGANIZATION_CREATED_SUCCESSFULLY"));
        let newCustomer = response_data.data.data.customer;
        this.getAllCustomerData();
        this.getServerStatusAndUsersCount();
        this.setState({
          customerId: newCustomer.id,
          showAddOrganizationModal: false
        });
      },
      error => {
        callBackForError(getMessage(error.code));
        return false;
      }
    );
  };

  handleDeleteOrgClick = () => {
    organisationAction.deleteCustomerAction(this.state.deleteCustomerId).then(
      response_data => {
        this.getAllCustomerData();
        this.getServerStatusAndUsersCount();
        this.setState({
          showConfirmationModalFlag: false
        });
        toastr.success(`${getMessage("ORGANIZATION_DELETED_SUCCESSFULLY")}`);
      },
      error => {
        if(error.code !== ERROR.NOT_AUTHORIZED)
          displayError(getMessage(error.code));
        this.setState({
          showConfirmationModalFlag: false
        });
      }
    );
  };

  gotoAddOrganization = () => {
    this.props.history.push(CONFIG.path.addOrganization)
  };

  gotoEditOrganization = (userId, customerId) => {
    this.showSpinner(); 
    let customerData = _.find(this.state.responseObject.data, object => {
      return object.id === customerId;
    });

    organisationAction.getCustomersAction(customerId).then(
      response_data => {
        customerData.logo = response_data.data.data.logo
      },
      error => {
        if(error.message) {
          toastr.error(error.message, {timeOut: TIMEOUT.SHORT});
        }
      }
    );  

    userAction.getUsersAction(userId).then(
      response_data => {
        customerData.admin = response_data.data.data
          ? response_data.data.data
          : [];
        this.setState({
          editOrganisationData: customerData,
          editOrganisationIndex: customerId
        });
        
        organisationAction.getCustomerStorageDetails(customerId).then(
          response_data => {
            let customer= this.state.editOrganisationData;
            customer.storageDetails = response_data.data.data
            this.setState({ editOrganisationData: customer })

            organisationAction.getCustomerRecordingStorageDetails(customerId).then(
              response_data => {
                customer.recordingStorageDetails = response_data.data.data
                this.setState({ editOrganisationData: customer })
                organisationAction.setOrganisationAction(customerData);
                this.props.history.push(CONFIG.path.editOrganization); 
              },
              error => {
                if(error.message) {
                  toastr.error(getMessage(error.code));
                }
                customerData.recordingStorageDetails = {}
                this.hideSpinner(); 
              }
            );

          },
          error => {
            if(error.message) {
              toastr.error(getMessage(error.code));
            }
            customerData.storageDetails = {}
            this.hideSpinner(); 
          }
        );
      },
      error => {
        if(error.message) {
          toastr.error(getMessage(error.code));
        }
        this.setState({
          editOrganisationData: customerData,
          editOrganisationIndex: customerId
        });
        this.hideSpinner(); 
      }
    );
  };

  showDeleteConfirmationModal = (customerId, customerName) => {
    this.setState({ showConfirmationModalFlag: true });
    this.setState({ deleteCustomerId: customerId, deleteTarget: customerName });
  };

  handleCancelClick = () => {
    this.setState({
      showAddOrganizationModal: false,
      showConfirmationModalFlag: false
    });
  };

  handleEditCancelClick = () => {
    this.setState({
      showEditOrganizationModal: false,
      editOrganisationData: customerObjectInitialState
    });
  };

  validateUserData = (data, callBackForError) => {
    this.isValidUsername(data.user.username, callBackForError);
  };

  isValidUsername = (username, callBackForError) => {
    if (username === "") callBackForError(getMessage("INVALID_EMAIL"));
    else if (!validateUserName(username))
      callBackForError(getMessage("INVALID_EMAIL"));
  };

  cancelSearchString = () => {
    this.setState({
      searchString: "",
      isSearchResult: false
    });
  };

  getAvailableModules = sortedAvailableModules => {
    let updatedAvailableModule = {};
    let loopingArray = Array.from(sortedAvailableModules);
    _.map(loopingArray, modulesAvailableItem => {
      switch (modulesAvailableItem) {
        case modulesAvailableConstant.AUDIO:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("AUDIO"),
            icon: ic_audio,
            hasPermission: true
          };
          break;

        case modulesAvailableConstant.AUDIO_VIDEO:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("VIDEO"),
            icon: ic_video,
            hasPermission: true
          };
          break;

        case modulesAvailableConstant.SCREENSHARE:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("SCREENSHARE"),
            icon: ic_share,
            hasPermission: true
          };
          break;

        case modulesAvailableConstant.PDF:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("PDF_EDITOR"),
            icon: ic_pdf,
            hasPermission: true
          };
          break;

        case modulesAvailableConstant.CANVAS:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("CANVAS"),
            icon: ic_canvas,
            hasPermission: true
          };
          break;

        case modulesAvailableConstant.CHAT:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("MSG"),
            icon: ic_message,
            hasPermission: true
          };
          break;

        case modulesAvailableConstant.LOCATION:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("LOCATION"),
            icon: ic_location,
            hasPermission: true
          };
          break;
        case modulesAvailableConstant.SNAPSHOT:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("SNAP_SHOT"),
            icon: ic_camera,
            hasPermission: true
          };
          break;
        case modulesAvailableConstant.APP_EMULATION:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("APP_EMULATION"),
            icon: ic_app_emulation,
            hasPermission: true
          };
          break;
        case modulesAvailableConstant.QR_CODE:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("QR_CODE"),
            icon: ic_QR_code,
            hasPermission: true
          };
          break;
        case modulesAvailableConstant.ALLOW_DOWNLOAD:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("ALLOW_DOWNLOAD"),
            icon: download_img,
            hasPermission: true
          };
          break;
        case modulesAvailableConstant.CO_BROWSE:
          updatedAvailableModule[modulesAvailableItem] = {
            label: getMessage("CO_BROWSE"),
            icon: ic_admin_co_browse,
            hasPermission: true
          };
          break;
      }

      return null;
    });
    return updatedAvailableModule;
  };

  handleSearchString = (searchString = this.state.searchString) => {
    this.setState({
      isSearchResult: true,
      searchString: searchString
    });
    var items = this.state.responseObject.data;
    let searchStringItem = [];
    if (searchString.length > 0) {
      searchStringItem = items.filter(function(i) {
        return i.name.toLowerCase().match(searchString.toLowerCase());
      });
      if(searchStringItem.length <= 0) {
        displayError(getMessage("RECORD_NOT_FOUND"));
      } else {
        toast.dismiss();
      }
      this.setState({
        searchedCustomer: { data: searchStringItem }
      });
    } else {
      this.setState({
        searchedCustomer: { data: items }
      });
    }
  };

  cancelSearchString = () => {
    this.setState({
      isSearchResult: false,
      searchString: ""
    });
  };

  renderSprinner() {
    return <Spinner showSpinner={this.state.spinnerVisibility} />;
  }
  showSpinner = () => {
    this.setState({
      spinnerVisibility: true
    });
  };

  hideSpinner = () => {
    this.setState({
      spinnerVisibility: false
    });
  };

getServerStatusAndUsersCount = () => {
  organisationAction.userStatisticsAction().then(
    response_data => {   
      let statstics = response_data.data.data;
      let serverCounts = this.state.summaryData;
      serverCounts.totalCustomers.value = statstics.totalCustomers;
      serverCounts.usedAndMaxCapacity.value = `${statstics.usedCapacity ? statstics.usedCapacity : 0}
      /${statstics.systemMaxCapacity ? statstics.systemMaxCapacity : 0}`;
      serverCounts.totalSessions.value = statstics.totalSessions;
      serverCounts.activeSessions.value = statstics.activeSessions!==null?statstics.activeSessions:0;
      serverCounts.totalTimeToDate.value = convertMinutesToDDhhmm(statstics.totalTimeToDate);

      this.setState({
        summaryData: serverCounts,
        isKurentoServerOn: statstics.kmsStatus
      });
    },
    error => {
      if (error.status === 404)
        displayError(getMessage("PAGE_NOT_FOUND"), "/", this);
    }
  );
};
render() {
  return (
    <div>
      {this.renderSprinner()}
      <DeleteConfirmationModal
        show={this.state.showConfirmationModalFlag}
        handleCancelClick={this.handleCancelClick}
        handleDeleteClick={this.handleDeleteOrgClick}
        isDeleteOrganization={true}
        deleteTarget={this.state.deleteTarget}
      />

      <Organisations
        gotoAddOrganization={this.gotoAddOrganization}
        responseObject={
          this.state.isSearchResult
            ? this.state.searchedCustomer
            : this.state.responseObject
        }
        gotoEditOrganization={this.gotoEditOrganization}
        showDeleteConfirmationModal={this.showDeleteConfirmationModal}
        getAvailableModules={this.getAvailableModules}
        history={this.props.history}
        subscribe={this.subscribe}
        ref={this.getStatus}
        handleSearchString={this.handleSearchString}
        onCancelButton={this.cancelSearchString}
        sortCustomerList = {this.sortCustomerList}
        showTable = {this.state.mountOrganisationList}
        currentActiveTab={this.props.currentActiveTab}
        clusterData={this.state.msClusterInfo}
        turnClusterData={this.state.turnClusterInfo}
        getClusterInfo={this.getClusterInfo}
        getTurnClusterInfo={this.getTurnClusterInfo}
        lastRefreshTime={this.state.lastRefreshTime}
        lastRefreshTimeTurn={this.state.lastRefreshTimeTurn}
        retireInstance={this.retireInstance}
        usingKmsCluster={this.props.usingKmsCluster}
        usingTurnCluster={this.props.usingTurnCluster}
        isKurentoServerOn={this.state.isKurentoServerOn}
        summaryData={this.state.summaryData}
        language={this.props.language}
      />
    </div>
  );
}

componentWillUnmount() {
  //toastr.removeByType("success");
  //toastr.removeByType("error");
  toast.dismiss();
}
}

const mapStateToProps = state => {
  return {
    currentActiveTab: state.OrganisationReducer.currentActiveTab,
    usingKmsCluster: state.UserReducer.usingKmsCluster,
    usingTurnCluster: state.UserReducer.usingTurnCluster,
    language: state.LanguageReducer.language
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganisationsContainer);
